import React from 'react';

import './styles/globalStyles.scss';
// import useTheme from './hooks/useTheme';
// import ThemeSchindler from './styles/themes/themeSchindler';

import { AppProvider } from './context/AppContext';
import AppNavigation from './navigation/AppNavigation';

// function ScrollToTop() {
// 	const { pathname } = useLocation();

// 	React.useEffect(() => {
// 		setTimeout(() => {
// 			window.scrollTo(0, 0);
// 		}, 400);
// 	}, [pathname]);

// 	return null;
// };

const App = () => {
	// useTheme(ThemeSchindler);

	return (
		<React.Fragment>
			<AppProvider>
				<AppNavigation />
			</AppProvider>
		</React.Fragment>
	);
};

export default App;
